module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/533a93f0d8b2d5ee66a7afc2a54cefb7.png";